import {
  EPromoType,
  IPromoInfoSchema,
} from '../../../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export function isMortgageButtonVisible(promoInfo: IPromoInfoSchema) {
  const isPartner = promoInfo.bank?.isPartner || false;

  return isPartner || promoInfo.promoType === EPromoType.CianMortgage;
}
